query ListCategories {
    categories {
        id
        icon

        # English when the category has it, otherwise whatever it does have —
        # without the argument the service returns every translation and the
        # tree rendered `name[0]`, so half the list came out in Czech.
        name(language: "en") {
            language
            text
        }

        public
        parentCategory {
            id
        }
    }
}
